// extracted by mini-css-extract-plugin
export default {"alert":"alert___aid6J","icon":"icon___g01P4"};